import {
  GoogleMap,
  Marker,
  MarkerClusterer,
  useJsApiLoader,
} from '@react-google-maps/api';
import * as React from 'react';
import styled from 'styled-components';

interface Props {
  country: any;
  activeShop: any;
  markers: any;
  onChangePointItem: any;
  isLoading: boolean;
  lang: any;
}

const MapWrapper = styled.div`
  height: 560px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ImageWrapper = styled.img`
  margin-right: 0;
  width: 100%;
  vertical-align: baseline;
`;

function DpdMap(props: Props) {
  const { country, lang, activeShop, markers, onChangePointItem } = props;
  const clustererRef = React.useRef<any>();

  React.useEffect(() => {
    clustererRef.current?.repaint();
  }, [markers.length]);

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyAtjlvnt8r2LXlW8Q8NnEvrP2nuditIfXY',
    language: 'sk',
    region: 'sk',
    libraries: ['places'],
  });
  const containerStyle = {
    width: '100%',
    height: '520px',
  };

  if (isLoaded) {
    return (
      <div className="">
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={
            activeShop
              ? {
                  lat: activeShop.latitude,
                  lng: activeShop.longitude,
                }
              : lang === 'cz'
              ? {
                  lat: 49.8724719,
                  lng: 15.81623,
                }
              : {
                  lat: 48.804929,
                  lng: 19.641018,
                }
          }
          zoom={activeShop ? 13 : 7}
          options={{
            streetViewControl: false,
            fullscreenControl: false,
            mapTypeControl: false,
            zoomControl: true,
            zoomControlOptions: {
              position: 9,
            },
            keyboardShortcuts: false,
          }}
        >
          <MarkerClusterer
            key={markers.length}
            onLoad={clusterer => (clustererRef.current = clusterer)}
            options={{
              imagePath:
                'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m', // so you must have m1.png, m2.png, m3.png, m4.png, m5.png and m6.png in that folder
            }}
          >
            {clusterer => {
              return markers.map(location => (
                <Marker
                  key={location.id}
                  position={{
                    lat: +location.latitude,
                    lng: +location.longitude,
                  }}
                  clusterer={clusterer}
                  noClustererRedraw={true}
                  onClick={() => {
                    onChangePointItem(location);
                  }}
                />
              ));
            }}
          </MarkerClusterer>
          {/* {markers.length > 0 ? (
            markers.map(marker => {
              return (
                <Marker
                  key={marker.id}
                  position={{ lat: marker.latitude, lng: marker.longitude }}
                  animation={marker.id === activeShop?.id ? 1 : 0}
                  icon={`/images/icons/dpd.svg`}
                  title={`marker`}
                  onClick={() => {
                    onChangePointItem(marker);
                  }}
                />
              );
            })
          ) : (
            <>
              {activeShop ? (
                <Marker
                  key={activeShop.latitude + activeShop.longitude}
                  position={{
                    lat: activeShop.latitude,
                    lng: activeShop.longitude,
                  }}
                  animation={1}
                  icon={`/images/icons/dpd.svg`}
                  title={`marker`}
                  onClick={() => {
                    onChangePointItem(activeShop);
                  }}
                />
              ) : (
                <></>
              )}
            </>
          )} */}
        </GoogleMap>
      </div>
    );
  } else {
    return (
      <MapWrapper className="h-[560px] w-full flex items-center justify-center">
        <ImageWrapper
          className="mr-0 w-full align-baseline"
          src="https://maps.googleapis.com/maps/api/staticmap?center=48.6690,19.6990&zoom=7&language=sk&size=935x560&key=AIzaSyDhMQJQb72UKLZJeQp59quzuisc86ewjYk"
          alt="map"
        />
      </MapWrapper>
    );
  }
}

function isMapEqual(prevProps, nextProps) {
  if (nextProps.isLoading) {
    return true;
  }
  return false;
}

export default React.memo(DpdMap, isMapEqual);
